"use strict";

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var core_1 = require("@emotion/core");

var react_1 = tslib_1.__importDefault(require("react"));

var typography = tslib_1.__importStar(require("../typography"));

var colors_1 = require("../colors");

var IconAlertSolid_1 = require("../icons/IconAlertSolid");

var IconInfoSolid_1 = require("../icons/IconInfoSolid");

var classnames_1 = tslib_1.__importDefault(require("classnames"));

exports.TextField = function (_a) {
  var autoFocus = _a.autoFocus,
      className = _a.className,
      defaultValue = _a.defaultValue,
      description = _a.description,
      disabled = _a.disabled,
      error = _a.error,
      helper = _a.helper,
      icon = _a.icon,
      _b = _a.inputAs,
      inputAs = _b === void 0 ? "input" : _b,
      label = _a.label,
      name = _a.name,
      onFocus = _a.onFocus,
      onBlur = _a.onBlur,
      onChange = _a.onChange,
      placeholder = _a.placeholder,
      showInfoIcon = _a.showInfoIcon,
      _c = _a.size,
      size = _c === void 0 ? "standard" : _c,
      type = _a.type,
      value = _a.value;
  return core_1.jsx(core_1.ClassNames, null, function (_a) {
    var css = _a.css,
        cx = _a.cx;
    var inputProps = {
      autoFocus: autoFocus,
      defaultValue: defaultValue,
      disabled: disabled,
      name: name,
      onFocus: onFocus,
      onBlur: onBlur,
      onChange: onChange,
      placeholder: placeholder,
      type: type,
      value: value,
      className: cx(css(tslib_1.__assign({
        backgroundColor: disabled ? colors_1.colors.silver.light : colors_1.colors.white,
        border: "solid 1px",
        borderColor: error ? colors_1.colors.red.base : colors_1.colors.silver.darker,
        "::placeholder": {
          color: disabled ? colors_1.colors.grey.lighter : colors_1.colors.grey.light,
          opacity: 1
        },
        borderRadius: 4,
        flex: 1,
        height: size === "standard" ? 36 : size === "small" ? 28 : 42
      }, size === "small" ? typography.base.small : typography.base.base, {
        marginRight: icon ? -30 : 0,
        paddingLeft: icon ? 34 : size === "small" ? 8 : 12,
        paddingRight: size === "small" ? 8 : 12,
        width: "100%",
        ":hover,  &[data-force-hover-state]": {
          borderColor: !disabled && !error ? colors_1.colors.grey.light : error ? colors_1.colors.red.base : colors_1.colors.silver.darker
        },
        ":focus, &[data-force-focus-state]": {
          borderColor: !disabled && !error ? colors_1.colors.blue.light : error ? colors_1.colors.red.base : colors_1.colors.silver.darker,
          outline: "none"
        }
      })))
    };
    return core_1.jsx("div", {
      className: className
    }, core_1.jsx("label", {
      className: cx(css(tslib_1.__assign({
        paddingBottom: 8
      }, typography.base.base, {
        fontWeight: 600
      })))
    }, label != null && core_1.jsx("div", {
      css: {
        marginBottom: 4
      }
    }, label), description != null && core_1.jsx("div", {
      css: tslib_1.__assign({}, typography.base.base, {
        color: colors_1.colors.black.base
      })
    }, description), core_1.jsx("div", {
      css: {
        marginTop: 8,
        position: "relative"
      }
    }, icon && core_1.jsx("div", {
      css: {
        position: "absolute",
        display: "inline-flex",
        left: 12,
        top: "50%",
        transform: "translateY(-50%)"
      }
    }, icon), react_1["default"].isValidElement(inputAs) ? react_1["default"].cloneElement(inputAs, tslib_1.__assign({}, inputProps, {
      className: classnames_1["default"](inputProps.className, inputAs.props.className)
    })) : react_1["default"].createElement(inputAs, inputProps))), core_1.jsx("div", {
      css: {
        marginTop: 8,
        alignItems: "center",
        position: "relative"
      }
    }, (helper || error) && core_1.jsx("div", {
      css: tslib_1.__assign({}, typography.base.small, {
        color: error ? colors_1.colors.red.base : colors_1.colors.grey.base,
        display: "flex",
        marginRight: 8,
        marginTop: 8,
        paddingLeft: size === "small" ? 8 : 12
      })
    }, error ? core_1.jsx(IconAlertSolid_1.IconAlertSolid, {
      css: {
        height: 15,
        marginRight: 8,
        position: "relative",
        top: 2,
        width: 15
      }
    }) : showInfoIcon && helper ? core_1.jsx(IconInfoSolid_1.IconInfoSolid, {
      css: {
        color: colors_1.colors.blue.base,
        height: 15,
        marginRight: 8,
        position: "relative",
        top: 2,
        width: 15
      }
    }) : null, core_1.jsx("div", null, error || helper))));
  });
};